import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';

type Props = {
  siteLabel: string;
  hasArea: boolean;
  canSetArea: boolean;
  onSetArea: () => void;
};

/** Site chip + empty-area Set area affordance (Epic 281-A). */
export const DeviceSiteAreaCell: React.FC<Props> = ({
  siteLabel,
  hasArea,
  canSetArea,
  onSetArea,
}) => (
  <Box>
    <Chip size="small" variant="outlined" color="info" label={siteLabel} />
    {!hasArea && (
      canSetArea ? (
        <Button
          size="small"
          sx={{ ml: 0.5, minWidth: 0, textTransform: 'none' }}
          onClick={onSetArea}
        >
          Set area
        </Button>
      ) : (
        <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
          —
        </Typography>
      )
    )}
  </Box>
);

export default DeviceSiteAreaCell;
